export default __webpack_public_path__ + "static/media/new-tag.4f82e3c2.svg";